<app-card #card [cardTitle]="'MISSING_REVIEWS.MISSING_ASSESSMENTS' | translate"
    [useExternalButtons]="true" 
    [showEdit]="isEditable" 
    [disabled]="!settingState.reviewPeriod.value">
    
    <div>
        <div>
            <div class="flex-horizontal">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>{{ 'MISSING_REVIEWS.SEARCH' | translate }}</mat-label>
                    <input matInput type="text" [formControl]="searchControl" autocomplete="off">
                    <button *ngIf="searchControl.value" matSuffix mat-icon-button [attr.aria-label]="'MISSING_REVIEWS.CLEAR' | translate" (click)="clearText()">
                      <mat-icon>close</mat-icon>
                    </button>
                    <mat-icon matSuffix>search</mat-icon>
                </mat-form-field>
                
                <div class="view-icons">
                    <mat-button-toggle-group [hideSingleSelectionIndicator]="true" [value]="viewMode" class="icons" *ngIf="isPanoramaOrAura">
                        <mat-button-toggle value="byEmployee" [attr.aria-label]="'MISSING_REVIEWS.GROUPED_BY_ASSESSOR' | translate" [title]="'MISSING_REVIEWS.GROUPED_BY_ASSESSOR' | translate" (click)="viewByEmployee()">
                          <mat-icon>segment</mat-icon>
                        </mat-button-toggle>
                        <mat-button-toggle value="aboutEmployee" [attr.aria-label]="'MISSING_REVIEWS.GROUPED_BY_ASSESSED' | translate" [title]="'MISSING_REVIEWS.GROUPED_BY_ASSESSED' | translate" (click)="viewAboutEmployee()">
                          <mat-icon>reorder</mat-icon>
                        </mat-button-toggle>
                    </mat-button-toggle-group>
                </div>
            </div>

            <ng-container *ngIf="items$ | async as items">
                <div class="message-panel">
                    {{ searchMessage }}
                </div>
                <div class="scroll-panel">
                    <app-dynamic-list-item [actionState]="card.actionState" [inlineEdit]="false" [noActions]="hasSubitems"
                        (edit)="rowEdit(item.itemSource, item.itemSource)"
                        (delete)="rowDelete(item.itemSource.mainItem.reviewPeriodEmployeeId)"
                        *ngFor="let item of items; index as i" [index]="i" [source]="item">
                        <div slot="readonly">
                            <div class="mainitems" [ngClass]="{'border-bottom': hasSubitems}">
                                <div class="flex-horizontal" >
                                    <div class="field-text" [title]="(viewMode === 'byEmployee' ? ('MISSING_REVIEWS.ASSESSOR_PERSON' | translate) : ('MISSING_REVIEWS.ASSESSED_PERSON' | translate)) + item.itemSource.mainItem.name">
                                        <div class="name"><strong>{{ item.itemSource.mainItem.name }}</strong></div>
                                        <div class="sub-text inactive-user-label" *ngIf="EmployeeHelper.isEmployeeInactive(item.itemSource.mainItem)">
                                            {{ 'EMPLOYEE.INACTIVE_USER_LABEL' | translate }}
                                        </div>
                                        <div class="sub-text">
                                            <span>{{ item.itemSource.mainItem.email ? item.itemSource.mainItem.email : item.itemSource.mainItem.userName }} </span>
                                            <span [title]="'MISSING_REVIEWS.UNIQUE_EMPLOYEE_IDENTIFIER' | translate">{{ item.itemSource.mainItem.employeeIdentifier ?? '' }}</span>
                                        </div>
                                        <div class="sub-text" [title]="'MISSING_REVIEWS.DEADLINE' | translate" *ngIf="item.itemSource.mainItem.deadline" [ngClass]="{'text-danger': isDateExpired(item.itemSource.mainItem.deadline)}">
                                            {{ item.itemSource.mainItem.deadline | datePlain }}
                                        </div>
                                    </div>
                                    <div class="row-action" *ngIf="card.actionState.editMode"></div>
                                </div>
                            </div>

                            <div class="subitems" *ngIf="item.itemSource.subItems && item.itemSource.subItems.length > 0">
                                <div class="flex-horizontal align-items-center" *ngFor="let subitem of item.itemSource.subItems">
                                    <div class="field-text" [title]="(viewMode === 'byEmployee' ? ('MISSING_REVIEWS.PERSON_TO_ASSESS' | translate) : ('MISSING_REVIEWS.ASSESSOR_PERSON_ALT' | translate)) + subitem.name">
                                        <div class="name"><strong>{{ subitem.name }}</strong></div>
                                        <div class="sub-text inactive-user-label" *ngIf="EmployeeHelper.isEmployeeInactive(subitem)">
                                            {{ 'EMPLOYEE.INACTIVE_USER_LABEL' | translate }}
                                        </div>
                                        <div class="sub-text">
                                            <div class="assessmentType">{{ getEmployeeType(subitem) }}</div>
                                            <span [title]="'MISSING_REVIEWS.EMPLOYEE_EMAIL' | translate">{{ subitem.email ? subitem.email : subitem.userName }} </span>
                                            <span [title]="'MISSING_REVIEWS.UNIQUE_EMPLOYEE_IDENTIFIER_ALT' | translate">{{ subitem.employeeIdentifier ?? '' }}</span>
                                        </div>
                                    </div>
                                    <div class="row-action" *ngIf="card.actionState.editMode">
                                        <button mat-icon-button class="icon-bt-md" (click)="rowEdit(item.itemSource, subitem)" [title]="'MISSING_REVIEWS.EDIT' | translate">
                                            <mat-icon>edit</mat-icon>
                                        </button>
                                    
                                        <button mat-icon-button color="primary" (click)="rowDelete(subitem.reviewPeriodEmployeeId)" [title]="'MISSING_REVIEWS.DELETE' | translate">
                                            <mat-icon>delete</mat-icon>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </app-dynamic-list-item>
                </div>
                <mat-paginator #paginator [length]="total"
                            [pageSize]="pageSize"
                            [pageSizeOptions]="pageSizeOptions"
                            (page)="pagingSettingsChanged($event)"
                            [attr.aria-label]="'MISSING_REVIEWS.CHOOSE_PAGE' | translate">
                </mat-paginator>

                <button mat-icon-button color="primary" (click)="add()" *ngIf="card.actionState.editMode" [title]="'MISSING_REVIEWS.ADD_ASSESSMENT_RELATIONSHIP' | translate">
                    <mat-icon>add_circle_outline</mat-icon>
                </button>

                <button mat-icon-button color="primary" *ngIf="card.actionState.editMode && isPanoramaOrAura" (click)="massAddPeers()" [title]="'MISSING_REVIEWS.MASS_PEER_ADDITION' | translate">
                    <mat-icon>queue</mat-icon>
                </button>
                
            </ng-container>
            
        </div>        
    </div>
</app-card>
